import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import ForgotPasswordModal from '../../components/auth/ForgotPasswordModal';
import './AuthPage.css';

const ForgotPasswordPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const message = location.state?.message;
  const messageType = location.state?.type || 'info';

  return (
    <div className="auth-page-container">
      {message && (
        <div className={`alert alert-${messageType}`}>
          {message}
        </div>
      )}
      
      {/* Use the ForgotPasswordModal with isOpen always true for the page version */}
      <ForgotPasswordModal 
        isOpen={true} 
        onClose={() => navigate('/')} 
        isStandalonePage={true} // Prop to indicate this is used as a page, not a modal
      />
    </div>
  );
};

export default ForgotPasswordPage;